import { Component, OnInit, OnDestroy } from "@angular/core";
import { signInWithRedirect, getCurrentUser } from "aws-amplify/auth";
import { SessionService } from "./services/session.service";
import { TokenService } from "./services/token";
import { Subscription } from "rxjs";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit, OnDestroy {
  emailUser: string = "";
  emailUserf: string = "";
  cierre_sesion: string = "";
  sessionIsActive: boolean = false;

  // Variables para mostrar alertas
  showSessionAlert: boolean = false;
  sessionAlertMessage: string = "";
  sessionExpired: boolean = false;
  inactivityTimeout: boolean = false;
  private tokenSubscription: Subscription | null = null;
  constructor(
    private sessionService: SessionService,
    private tokenService: TokenService
  ) {}

  async ngOnInit() {
    console.log("🚀 AppComponent iniciando...");
    this.checkStoredSessionStatus();
    await this.initializeSession();
  }

  ngOnDestroy() {
    console.log("🛑 AppComponent destruyendo...");
    if (this.tokenSubscription) {
      this.tokenSubscription.unsubscribe();
    }

    this.sessionService.dispose();
  }
  /**
   * Inicializa la sesión y el monitoreo
   */
  private async initializeSession() {
    try {
      console.log("🔍 initializeTokenAndMonitoring...");

      // Si hay usuario, intentar obtener el token
      await this.initializeTokenAndMonitoring();
    } catch (error) {
      console.log("❌ No hay usuario autenticado:", error);
      // No hay usuario autenticado, no iniciar monitoreo
      this.sessionIsActive = false;
    }
  }
  /**
   * Inicializa el token y el monitoreo de sesión
   */
  private async initializeTokenAndMonitoring() {
    console.log("🔑 Inicializando token y monitoreo...");

    // Si el token ya está listo, iniciar monitoreo inmediatamente
    if (this.tokenService.isTokenReady()) {
      console.log("✅ Token ya está listo, iniciando monitoreo...");
      this.startSessionMonitoring();
    } else {
      console.log("⏳ Token no está listo, esperando...");

      // Suscribirse a los cambios del token
      this.tokenSubscription = this.tokenService.tokenReady$.subscribe(
        (ready) => {
          console.log("🔔 Estado del token cambió:", ready);

          if (ready) {
            console.log("✅ Token listo, iniciando monitoreo...");
            this.startSessionMonitoring();
          } else {
            console.log("❌ Token no disponible, deteniendo monitoreo...");
            this.sessionService.stopMonitoring();
            this.sessionIsActive = false;
          }
        }
      );

      // También intentar refrescar el token para asegurar que esté disponible
      try {
        console.log("🔄 Intentando refrescar token...");
        await this.tokenService.refreshToken();
      } catch (error) {
        console.error("❌ Error refrescando token en inicialización:", error);
      }
    }
  }
  /**
   * Inicia el monitoreo de sesión
   */
  private startSessionMonitoring() {
    if (!this.sessionService.isSessionClosed) {
      console.log("🎯 Iniciando monitoreo de sesión...");
      this.sessionService.startMonitoring();
      this.sessionIsActive = true;

      // Opcional: obtener información del usuario
      this.loadUserInfo();
    } else {
      console.log("⚠️ No se puede iniciar monitoreo - sesión ya cerrada");
    }
  }
  /**
   * Carga información del usuario (opcional)
   */
  private async loadUserInfo() {
    try {
      const user = await getCurrentUser();
      this.emailUser = user.signInDetails?.loginId || user.username || "";
      console.log("👤 Usuario cargado:", this.emailUser);
    } catch (error) {
      console.error("❌ Error cargando información del usuario:", error);
    }
  }
  /**
   * Comprueba si hay un estado de sesión almacenado en localStorage
   */
  private checkStoredSessionStatus() {
    const sessionStatus = localStorage.getItem("session_status");
    console.log("📋 Estado de sesión almacenado:", sessionStatus);

    if (sessionStatus) {
      localStorage.removeItem("session_status");
      this.sessionExpired = true;
      this.inactivityTimeout = sessionStatus === "inactivity";
      this.showSessionAlert = true;
      this.sessionAlertMessage = this.inactivityTimeout
        ? "Su sesión fue cerrada debido a inactividad."
        : "Su sesión ha expirado. Por favor, inicie sesión nuevamente.";

      console.log("⚠️ Mostrando alerta de sesión:", this.sessionAlertMessage);
    }
  }

  handleSignInClick() {
    console.log("🔐 Iniciando proceso de autenticación...");
    signInWithRedirect({ provider: { custom: "AzureEntra" } })
      .then((result) => {
        console.log("✅ Inicio de sesión exitoso", result);
      })
      .catch((error) => {
        console.error("❌ Error en inicio de sesión", error);
      });
  }

  salga() {
    console.log("👋 Cerrando sesión...");
    this.sessionIsActive = false;
    this.sessionService.logout();
  }

  /**
   * Cierra el mensaje de alerta de sesión
   */
  closeSessionAlert() {
    console.log("✖️ Cerrando alerta de sesión");
    this.showSessionAlert = false;
  }
}
